import { combineReducers } from 'redux';

import {
  SET_REQUIRED_FIELDS_FILTERS,
  RESET_REQUIRED_FIELDS_FILTERS,
  SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA,
} from './actionTypes';

const requiredFieldsFiltersInitialState = {
  aggregatorID: '',
  payerID: '',
};

const requiredFieldsGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const requiredFieldsFiltersReducer = (
  state = requiredFieldsFiltersInitialState,
  { type = '', filters = { ...requiredFieldsFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_REQUIRED_FIELDS_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_REQUIRED_FIELDS_FILTERS:
      return {
        ...state,
        ...requiredFieldsFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentRequiredFieldsGridSortCriteriaReducer = (
  state = requiredFieldsGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...requiredFieldsGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_REQUIRED_FIELDS_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const requiredFieldsReducer = combineReducers({
  requiredFieldsFilters: requiredFieldsFiltersReducer,
  requiredFieldsGridSortCriteria: currentRequiredFieldsGridSortCriteriaReducer,
});

export {
  requiredFieldsReducer,
  requiredFieldsFiltersInitialState,
  requiredFieldsGridSortCriteriaInitialState,
};
